import { _ as e } from "./main29.js";
var a = e, t = a(Object, "create"), v = t;
export {
  v as _
};
